@let profileImage = this.profileImage();
@let initials = this.initials();

<div
  class="avatar"
  [style.--avatar-size]="size()"
  [class.placeholder]="!profileImage && !initials"
  [class.i]="hasImage() || !user()"
  [class.square]="type() === 'square'"
  [ngClass]="[!profileImage && !initials ? 'placeholder' : '', letterGroup()]"
>
  @if (profileImage) {
    <img
      src
      [src]="profileImage"
      [alt]="altText()"
      loading="lazy"
      decoding="async"
      (error)="onImageFailed()"
    />
  } @else if (initials) {
    <span class="initials">{{ initials }}</span>
  } @else {
    <ui-icon name="user-02" variant="stroke" class="icon" />
  }
</div>
